module.exports = __webpack_public_path__ + "img/7-i.910ced8d.png";